(function (angular) {
    'use strict';

    angular.module('shared')
        .directive("messageParts", ["profileHelper", "profilesService", "$stateParams", "$timeout", "uploadFileService", "utilService", function (profileHelper, profilesService, $stateParams, $timeout, uploadFileService, utilService) {
            return {
                restrict: 'A',
                replace: false,
                scope: {
                    msgData: "=",
                    messageParts: "=",
                    channels: "=",
                    channel: "=",
                    template: "@",
                    teamName: "@",
                    smsName: "@",
                    fbName: "@"
                },
                templateUrl: function (elem, attr) {
                    var template = attr.template == 'preview' ? 'preview.' : '';
                    return 'shared/directiveTemplates/directive.messageParts.' + template + 'html';
                },
                // templateUrl: "shared/directiveTemplates/directive.messageParts.html",
                link: function ($scope, element, attrs) {
                    function getProfileSchema() {
                        if (!$scope.profileSchema) {
                            $scope.profileSchema = [];
                            var schema = profileHelper.getSchema();
                            if (!schema.length) {
                                profilesService.getProfileSchema($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        profileHelper.setSchema(result);
                                        for (var i in result) {
                                            if (!result[i].onlyObjects && !result[i].name.startsWith('_') && result[i].name != 'id') {
                                                $scope.profileSchema.push(result[i]);
                                            }
                                        }
                                    });
                            }
                            else {
                                for (var i in schema) {
                                    if (!schema[i].onlyObjects && !schema[i].name.startsWith('_') && schema[i].name != 'id') {
                                        $scope.profileSchema.push(schema[i]);
                                    }
                                }
                            }
                        }
                    }

                    $scope.$watch('channel', function (newVal, oldVal) {
                        if (oldVal && newVal && newVal != oldVal) {
                            $scope.messageParts = [];
                        }
                    });

                    $scope.containText = function () {
                        for (var i in $scope.messageParts) {
                            if ($scope.messageParts[i].type == 'text/plain') return true;
                        }
                        return false;
                    };
                    $scope.deleteMessage = function (index) {
                        $scope.messageParts.splice(index, 1);
                    };
                    function setFocus() {
                        $scope.lastFocused = document.activeElement;
                        element.find("textarea").removeClass('c-black');
                        element.find($scope.lastFocused).addClass('c-black');
                    }
                    $timeout(function () {
                        element.find("textarea").focus(setFocus);
                    });
                    $timeout(function () {
                        if ($scope.messageParts.map(function (a) { return a.type; }).includes('text/plain')) {
                            getProfileSchema();
                            element.find("textarea").focus(setFocus);
                            $scope.lastFocused = element.find("textarea")[0];
                            element.find($scope.lastFocused).addClass('c-black');
                            $scope.$watch('messageParts', watchText, true);
                        }
                    });
                    $scope.addText = function () {

                        $scope.messageParts.push({
                            type: 'text/plain',
                            data: ''
                        });
                        getProfileSchema();
                        $scope.$watch('messageParts', watchText, true);

                        $timeout(function () {
                            if (element.find(".single-message:last-child")[0]) {
                                element.find(".single-message:last-child")[0].scrollIntoView();
                            }
                            element.find("textarea").focus(setFocus);
                            var counter = 0;
                            for (var i in $scope.messageParts) {
                                if ($scope.messageParts[i].type == 'text/plain') counter++;
                                if (counter > 1) break;
                            }
                            if (counter == 1) {
                                $scope.lastFocused = element.find("textarea")[0];
                            }
                        });
                    };

                    function watchText(newValue, oldValue) {
                        var text;
                        for (var i in newValue) {
                            if (newValue[i].type == "text/plain") {
                                text = newValue[i].data;
                            }
                        }
                        if (typeof text !== 'undefined') {
                            if (text.match(/{{(.|\n)*?}}/g)) {
                                $scope.propertyAlert = true;
                            }
                            else {
                                $scope.propertyAlert = false;
                            }
                            $scope.msgData = utilService.msgCounter(text);
                        }
                        else if (oldValue) {
                            $scope.msgData = {
                                bIsUnicode: false,
                                charCount: 0,
                                msgCount: 0
                            };
                        }
                    }
                    $scope.addImage = function () {
                        uploadFileService.uploadFile().then(function (data) {
                            $scope.messageParts.push({
                                type: data.type,
                                url: data.url,
                                size: data.size,
                                name: data.name
                            });
                            $timeout(function () {
                                if (element.find(".single-message:last-child")[0]) {
                                    element.find(".single-message:last-child")[0].scrollIntoView();
                                }
                            });

                        });

                    };

                    $scope.addLink = function () {
                        $scope.messageParts.push({
                            type: 'text/plain',
                            data: ''
                        });
                    };

                    $scope.insertText = function ($index) {
                        var text = "{{profile." + $scope.profileSchema[$index].path + "}}";
                        var input = $scope.lastFocused;
                        if (input === undefined) { return; }
                        var scrollPos = input.scrollTop;
                        var pos = 0;
                        var browser = ((input.selectionStart || input.selectionStart == "0") ?
                            "ff" : (document.selection ? "ie" : false));
                        if (browser == "ie") {
                            input.focus();
                            var range = document.selection.createRange();
                            range.moveStart("character", -input.value.length);
                            pos = range.text.length;
                        }
                        else if (browser == "ff") {
                            pos = input.selectionStart;
                        }
                        var front = (input.value).substring(0, pos);
                        var back = (input.value).substring(pos, input.value.length);
                        input.value = front + text + back;
                        pos = pos + text.length;
                        if (browser == "ie") {
                            input.focus();
                            var range = document.selection.createRange();
                            range.moveStart("character", -input.value.length);
                            range.moveStart("character", pos);
                            range.moveEnd("character", 0);
                            range.select();
                        }
                        else if (browser == "ff") {
                            input.selectionStart = pos;
                            input.selectionEnd = pos;
                            input.focus();
                        }
                        input.scrollTop = scrollPos;
                        element.find(input).trigger('input');
                        autosize.update(element.find(input));
                    };
                }
            };
        }]);
})(window.angular);